import { topicPartQuestionRepository } from "../../../providers/repositories/topicPartQuestionRepository";
import { TopicPartQuestion } from "../entities/TopicPartQuestion";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const getAllTopicPartQuestionsUseCase = {
    async exec(topicPartId: number | string): Promise<TopicPartQuestion[]> {
        try {
            return await topicPartQuestionRepository.getAll(topicPartId);
        } catch (error) {
            Logger.error("getAllTopicPartQuestionsUseCase", error);
            toast.error(t("action.error"));
        }
        return [];
    },
};
